import { Inject, Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { OktaAuth } from '@okta/okta-auth-js';
import { OKTA_AUTH } from '@okta/okta-angular';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  // TODO: get api host from configuration or something
  constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.getAccessToken()).pipe(
      switchMap(token => this.processRequestWithToken(token, req, next))
    );
  }

  async getAccessToken(): Promise<string | undefined> {
    let token = this.oktaAuth.getIdToken();
    if (token && this.isTokenExpired(token)) {
      await this.oktaAuth.tokenManager.renew('idToken');
      token = this.oktaAuth.getIdToken();
    }
    return token;
  }

  private isTokenExpired(token: string): boolean {
    const tokenPayload = JSON.parse(atob(token.split('.')[1]));
    const expiryTime = tokenPayload.exp * 1000;
    return Date.now() > expiryTime;
  }

  private processRequestWithToken(token: string | undefined, req: HttpRequest<any>, next: HttpHandler) {
    if (token) {
      req = req.clone({
        url: req.url,
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
    return next.handle(req);
  }
}
